module.exports = __webpack_public_path__ + "img/payment-logos-fnb.64172272.png";